import { __assign, __rest } from "tslib";
import React, { useState } from 'react';
import { GALLERY_CONSTS, ProGallery } from 'pro-gallery';
import { useAccessibility } from './nativeAccessibilityHelper'; // ~1kb
import { useItems } from './itemsHelper'; // ~1kb
import { getResizeMediaUrl, TPADimensionsHelper, } from '@wix/photography-client-lib';
import { LayoutFixer } from '@wix/pro-gallery-layout-fixer';
import optionsConverter from './proGalleryOptionsBuilder';
import { processLayouts, addPresetOptions, extendNestedOptionsToIncludeOldAndNew, optionsMap } from 'pro-gallery-lib';
import FullscreenWrapper from './components/fullscreen/fullscreenWrapper';
// @ts-ignore
import { getCustomComponents } from '@wix/pro-gallery-info-element';
import './gallery.global.scss';
import ReactDOM from 'react-dom';
export var WixProGallery = function (_a) {
    var id = _a.id, itemsSrc = _a.itemsSrc, container = _a.container, styles = _a.styles, isMobile = _a.isMobile, deviceType = _a.deviceType, viewMode = _a.viewMode, setLayoutHeightImp = _a.setLayoutHeightImp, staticMediaUrls = _a.staticMediaUrls, // TODO, these replace the hardcoded wixstatic urls. they should be provided by the platform.
    props = __rest(_a, ["id", "itemsSrc", "container", "styles", "isMobile", "deviceType", "viewMode", "setLayoutHeightImp", "staticMediaUrls"]);
    function wasCreatedByNewInfo() {
        // return options?.controllers?.experimental?.useNewInfo === 'true'
        var x = styles.controllers_experimental_useNewInfo;
        return x === true || x === 'true' || x === 'yes';
    }
    // let shouldUseNewInfo = props.experimentalFeatures.newInfoElements === true
    var shouldUseNewInfo = wasCreatedByNewInfo();
    var isAccessibilityEnabled = true; //if this can come from props it might be better. in ooi it does come as a site setting.
    var isAccessible = useAccessibility(isAccessibilityEnabled).isAccessible;
    var itemsToRender = useItems(props.items, itemsSrc).itemsToRender;
    var _b = useState(-1), fullscreenIdx = _b[0], setFullscreenIdx = _b[1];
    var _c = optionsConverter(styles, shouldUseNewInfo), convertedOptions = _c.galleryOptions, fullscreenOptions = _c.fullscreenOptions;
    var migratedOptions = extendNestedOptionsToIncludeOldAndNew(convertedOptions);
    var options = processLayouts(addPresetOptions(migratedOptions), true);
    if (shouldUseNewInfo) {
        options.EXPERIMENTALallowParallelInfos = true;
    }
    var isUnKnownContainer = (function () {
        var _a = container || {}, width = _a.width, height = _a.height, isDefaultContainer = _a.isDefaultContainer;
        var scrollDirection = options.scrollDirection;
        var isMissingWidth = typeof width !== 'number';
        var isMissingHeight = typeof height !== 'number';
        return (isDefaultContainer ||
            isMissingWidth ||
            (scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL &&
                isMissingHeight));
    })();
    var isPrerenderMode = (function () {
        var isSEO = viewMode === GALLERY_CONSTS.viewMode.SEO;
        return isUnKnownContainer && !isSEO;
    })();
    var handleNewGalleryStructure = function (newGalleryStructureData) {
        // TODO when this is ready - take it outside of this file
        var numOfItems = newGalleryStructureData.numOfItems, galleryContainer = newGalleryStructureData.container, galleryOptions = newGalleryStructureData.options, layoutHeight = newGalleryStructureData.layoutHeight, isInfinite = newGalleryStructureData.isInfinite, isFixedHorizontlaGalleryRatio = newGalleryStructureData.isFixedHorizontlaGalleryRatio, updatedHeight = newGalleryStructureData.updatedHeight;
        var setHeightImp = function (newHeight) {
            if (typeof setLayoutHeightImp === 'function') {
                setLayoutHeightImp(newHeight);
            }
        };
        // TBD check offsetTop
        TPADimensionsHelper.setWixHeight({
            height: layoutHeight,
            offsetTop: 0,
            styleParams: galleryOptions,
            container: galleryContainer,
            numOfItems: numOfItems,
            isInfinite: isInfinite,
            isFixedHorizontlaGalleryRatio: isFixedHorizontlaGalleryRatio,
            updatedHeight: updatedHeight,
            setHeightImp: setHeightImp,
            viewMode: viewMode === 'EDIT' ? 'editor' : viewMode,
            clearHeight: undefined,
        });
    };
    container = !isUnKnownContainer
        ? container
        : {
            width: isMobile ? 320 : 980,
            height: 800,
        };
    var eventsListener = function (eventName, eventData) {
        switch (eventName) {
            case 'GALLERY_CHANGE':
                handleNewGalleryStructure(eventData);
                break;
            case GALLERY_CONSTS.events.ITEM_ACTION_TRIGGERED:
                handleItemActionTriggered(eventData);
                break;
            default:
                break;
        }
        if (typeof props.eventsListener === 'function') {
            props.eventsListener(eventName, eventData);
        }
    };
    var handleItemActionTriggered = function (eventData) {
        if (['EXPAND', 'FULLSCREEN'].includes(fullscreenOptions[optionsMap.behaviourParams.item.clickAction])) {
            setFullscreenIdx(eventData.idx);
        }
    };
    var renderFullscreen = function () {
        return fullscreenIdx >= 0
            ? ReactDOM.createPortal(React.createElement(FullscreenWrapper, { deviceType: deviceType, items: itemsToRender, options: styles, createMediaUrl: getResizeMediaUrl, staticMediaUrls: staticMediaUrls, setFullscreenIdx: setFullscreenIdx, fullscreenIdx: fullscreenIdx, viewMode: viewMode }), document.body)
            : null;
    };
    var shouldControlHorizontalAlignment = false;
    var shouldUseLineHeightFixer = true;
    var shouldInsertDefaults = true;
    var prerenderStyle = isPrerenderMode ? { display: 'none' } : {};
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pro-gallery-wix-wrapper", style: prerenderStyle },
            React.createElement(ProGallery, __assign({}, __assign(__assign({}, props), { id: id,
                options: options,
                container: container, 
                // @ts-ignore
                createMediaUrl: getResizeMediaUrl(staticMediaUrls), totalItemsCount: itemsToRender.length, items: itemsToRender, settings: {
                    isAccessible: isAccessible,
                }, eventsListener: eventsListener,
                isPrerenderMode: isPrerenderMode, customComponents: getCustomComponents(shouldUseNewInfo, props, shouldControlHorizontalAlignment, shouldUseLineHeightFixer, shouldInsertDefaults, props.customInfoRenderer, props.customHoverRenderer, options.infoElementsOptions) }))),
            React.createElement(LayoutFixer, __assign({ id: id }, {
                items: itemsToRender,
                options: options,
                isPrerenderMode: isPrerenderMode,
            }, { useNativeLayoutFixer: true })),
            renderFullscreen())));
};
//# sourceMappingURL=gallery.js.map